'use strict';

/**
 * @param {Function} fn
 * @param {number} wait
 * @returns {Function}
 */
export default function debounce(fn, wait) {
    let timeout;
    function debounced(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), wait);
    }
    debounced.cancel = function cancel() {
        clearTimeout(timeout);
        timeout = undefined;
    };
    return debounced;
}
